import {
  CalculateDiscountDocument,
  CalculateDiscountQuery,
  CalculateDiscountQueryVariables,
  NoDiscountReason,
} from "../GeneratedGraphQL";

import { defaultOrganisation } from "./organisation";
import { defaultService } from "./service";
import { MockedResponse } from "@apollo/client/testing";
import { userDetailsStripeInvoice } from "./userDetails";

const successRequestVariables: CalculateDiscountQueryVariables = {
  code: "TEST_CODE",
  email: userDetailsStripeInvoice.email,
  organisationId: defaultOrganisation._id,
  servicePrices: [{ price: 1875, serviceId: defaultService._id }],
};

export const discountCodeRequestSuccess: MockedResponse<CalculateDiscountQuery> =
  {
    request: {
      query: CalculateDiscountDocument,
      variables: successRequestVariables,
    },
    result: {
      data: {
        discountCodeByCode: {
          calculatedDiscount: {
            __typename: "CalculatedDiscounts",
            discounts: [
              {
                discount: 1000,
                discountedPrice: 875,
                serviceId: defaultService._id,
                servicePriceId: undefined,
              },
            ],
          },
        },
      },
    },
  };

export const discountCodeNotFoundRequestSuccess: MockedResponse<CalculateDiscountQuery> =
  {
    request: {
      query: CalculateDiscountDocument,
      variables: successRequestVariables,
    },
    result: { data: { discountCodeByCode: undefined } },
  };

export const discountExpiredRequestSuccess: MockedResponse<CalculateDiscountQuery> =
  {
    request: {
      query: CalculateDiscountDocument,
      variables: successRequestVariables,
    },
    result: {
      data: {
        discountCodeByCode: {
          calculatedDiscount: {
            __typename: "NoDiscount",
            noDiscountReason: NoDiscountReason.Expired,
          },
        },
      },
    },
  };

export const discountNotActiveRequestSuccess: MockedResponse<CalculateDiscountQuery> =
  {
    request: {
      query: CalculateDiscountDocument,
      variables: successRequestVariables,
    },
    result: {
      data: {
        discountCodeByCode: {
          calculatedDiscount: {
            __typename: "NoDiscount",
            noDiscountReason: NoDiscountReason.NotActive,
          },
        },
      },
    },
  };

export const discountMaxClaimsReachedRequestSuccess: MockedResponse<CalculateDiscountQuery> =
  {
    request: {
      query: CalculateDiscountDocument,
      variables: successRequestVariables,
    },
    result: {
      data: {
        discountCodeByCode: {
          calculatedDiscount: {
            __typename: "NoDiscount",
            noDiscountReason: NoDiscountReason.MaxClaimsReached,
          },
        },
      },
    },
  };

export const discountNoValidServicesRequestSuccess: MockedResponse<CalculateDiscountQuery> =
  {
    request: {
      query: CalculateDiscountDocument,
      variables: successRequestVariables,
    },
    result: {
      data: {
        discountCodeByCode: {
          calculatedDiscount: {
            __typename: "NoDiscount",
            noDiscountReason: NoDiscountReason.NoValidServices,
          },
        },
      },
    },
  };

export const discountCodeRequestError: MockedResponse<CalculateDiscountQuery> =
  {
    error: new Error("Oops, something went wrong on our end"),
    request: {
      query: CalculateDiscountDocument,
      variables: successRequestVariables,
    },
  };
